function convertToSlug(Text) {
  return Text.toLowerCase()
    .replace(/ /g, "_")
    .replace(/[^\w-]+/g, "");
}

async function isAppointmentSlotsAvailable(appointmentDate, appointmentTime) {
  let headers = new Headers();
  headers.append("Content-Type", "application/json");
 return await fetch(
    `https://prescription.clinikally.in/webhooks/check-appointments.php?action=CHECK_APPOINTMENTS&appointment_date=${appointmentDate}&appointment_time=${appointmentTime}`
  )
    .then((rresponse) => rresponse.json())
    .then((rresponse) => { 
      return rresponse;
    });
}

async function getAppointmentCart() {
  return await fetch("/cart.js", {
    method: "GET",
  })
    .then((response) => {
      return response.json();
    })
    .then((cartState) => {
      return cartState;
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

var getCartData = getAppointmentCart();

const urlaParams = new URLSearchParams(window.location.search);
const editVid = urlaParams.get("edit");

getCartData.then(async function (cartData) {
  cartData.items.forEach(async (item) => {
    if (item.sku === "VIDEO-CON") {
      var consertDateTime = item.properties.Date + " " + item.properties.Time;

      // console.log("consertDateTime", new Date() >= new Date(consertDateTime));

      var availableObj = await isAppointmentSlotsAvailable(item.properties.Date, item.properties.Time);
      // console.log('availableObj', availableObj);
      if(availableObj.status==='error')
      {
        var errorShow = document.createElement("div");
        errorShow.setAttribute("class", "calendar-waring");
        errorHTML = "";
        errorHTML +=
          "<style>ul.clinikally-calendar__cart_error {position: fixed; list-style: none; font-size: 16px; margin: 0; font-family: sans-serif; bottom: 16px; left: 0px; right: 16px; max-width: 768px; z-index: 2147483647; background: #fff; padding: 8px; box-shadow: inset 0 3px 0 0 #de3618, inset 0 0 0 0 transparent, 0 0 0 1px rgba(63,63,68,.05), 0 1px 3px 0 rgba(63,63,68,.15);	background-color: #fdf3f0;} .clinikally-calendar__cart_error_row { display: flex; align-items: center;} .clinikally-calendar__cart_error_img_wrapper { background: #DDD; max-width: 56px; margin-right: 16px;} .clinikally-calendar__cart_error_img_wrapper > img { width: 100%; height: auto; } .clinikally-calendar__cart_error_row > div > strong { color: #000; font-weight: bold;font-size: 15px; } .clinikally-calendar__cart_error a{background: #8C30F5; color: #fff; padding: 5px; border-radius: 30px; font-size: 13px; margin-left: 15px;} @media(max-width:767px){ ul.clinikally-calendar__cart_error{left:0; right:0; z-index: 9;} body.page-index ul.clinikally-calendar__cart_error{bottom: 64px;} body.page-video-consult-v3 ul.clinikally-calendar__cart_error{bottom: 123px;} body.page-product ul.clinikally-calendar__cart_error{bottom: 62px;} body.page-collection ul.clinikally-calendar__cart_error{bottom: 45px;}}</style>";
        errorHTML +=
          '<ul class="clinikally-calendar__cart_error"><li class="clinikally-calendar__cart_error_item"><div class="clinikally-calendar__cart_error_row"><div class="clinikally-calendar__cart_error_img_wrapper"><img src="' +
          item.image +
          '"></div><div><strong>' +
          item.title +
          "</strong><a href='/products/video-consult-with-a-skin-hair-specialist?edit=yes'>Edit Booking</a><br/><span>Unfortunately this time slot is not available anymore. Please remove this item and book again.</span></div></div></li></ul>";

        errorShow.innerHTML = errorHTML;
        document.body.appendChild(errorShow);

        if(document.querySelector(".cart__checkout-button"))
        {
          document.querySelector(".cart__checkout-button").setAttribute("disabled", "disabled");
        }
        
        if(document.querySelector(".rebuy-cart__checkout-button"))
        {
          document.querySelector(".rebuy-cart__checkout-button").setAttribute("disabled", "disabled");
        }
        
        if(document.querySelector("#continue_button"))
        {
          document.querySelector("#continue_button").setAttribute("disabled", "disabled");
        }
      }

      if (new Date() >= new Date(consertDateTime)) {
        // console.log("item.properties", item.properties);
       if (editVid === "yes") {
          var propertiesArray = [];
          for (const [key, value] of Object.entries(item.properties)) {
            var conkey = convertToSlug(key);
            propertiesArray[conkey] = value;
          }

          if (propertiesArray) {
            //   console.log("propertiesArray", propertiesArray);
            //  console.log("age", propertiesArray["age"]);
            if (propertiesArray["age"]) {
              document.querySelector('[name="properties[Age]"]').value =
                propertiesArray["age"];
            }
            if (propertiesArray["gender"]) {
              document.querySelector('[name="properties[Gender]"]').value =
                propertiesArray["gender"];
            }

            /*
            if (propertiesArray["skin_concern"]) {
              var checkBoxes = document.querySelectorAll(
                '[name="properties[Skin Concern]"]'
              );
              for (var i = 0; i < checkBoxes.length; i++) {
                if (checkBoxes[i].value === propertiesArray["skin_concern"]) {
                  checkBoxes[i].setAttribute("checked", true);
                }
              }
            }
            if (propertiesArray["hair_concern"]) {
              var checkBoxes = document.querySelectorAll(
                '[name="properties[Hair Concern]"]'
              );
              for (var i = 0; i < checkBoxes.length; i++) {
                if (checkBoxes[i].value === propertiesArray["hair_concern"]) {
                  checkBoxes[i].setAttribute("checked", true);
                }
              }
            }
             
            if (
              propertiesArray[
                "are_you_consulting_on_clinikally_for_the_first_time"
              ]
            ) {
              var radiobtn = document.querySelectorAll(
                "properties[Are you consulting on Clinikally for the first time?]"
              );
              if (radiobtn) {
                for (var i = 0; i < radiobtn.length; i++) {
                  if (
                    radiobtn[i].value ===
                    propertiesArray[
                      "are_you_consulting_on_clinikally_for_the_first_time"
                    ]
                  ) {
                    radiobtn[i].setAttribute("checked", true);
                  }
                }
              }
            }
            */
          }
        }
        

        var errorShow = document.createElement("div");
        errorShow.setAttribute("class", "calendar-waring");
        errorHTML = "";
        errorHTML +=
          "<style>ul.clinikally-calendar__cart_error {position: fixed; list-style: none; font-size: 16px; margin: 0; font-family: sans-serif; bottom: 16px; left: 0px; right: 16px; max-width: 768px; z-index: 2147483647; background: #fff; padding: 8px; box-shadow: inset 0 3px 0 0 #de3618, inset 0 0 0 0 transparent, 0 0 0 1px rgba(63,63,68,.05), 0 1px 3px 0 rgba(63,63,68,.15);	background-color: #fdf3f0;} .clinikally-calendar__cart_error_row { display: flex; align-items: center;} .clinikally-calendar__cart_error_img_wrapper { background: #DDD; max-width: 56px; margin-right: 16px;} .clinikally-calendar__cart_error_img_wrapper > img { width: 100%; height: auto; } .clinikally-calendar__cart_error_row > div > strong { color: #000; font-weight: bold;font-size: 15px; } .clinikally-calendar__cart_error a{background: #8C30F5; color: #fff; padding: 5px; border-radius: 30px; font-size: 13px; margin-left: 15px;} @media(max-width:767px){ ul.clinikally-calendar__cart_error{left:0; right:0; z-index: 9;} body.page-index ul.clinikally-calendar__cart_error{bottom: 64px;} body.page-video-consult-v3 ul.clinikally-calendar__cart_error{bottom: 123px;} body.page-product ul.clinikally-calendar__cart_error{bottom: 62px;} body.page-collection ul.clinikally-calendar__cart_error{bottom: 45px;}}</style>";
        errorHTML +=
          '<ul class="clinikally-calendar__cart_error"><li class="clinikally-calendar__cart_error_item"><div class="clinikally-calendar__cart_error_row"><div class="clinikally-calendar__cart_error_img_wrapper"><img src="' +
          item.image +
          '"></div><div><strong>' +
          item.title +
          "</strong><a href='/products/video-consult-with-a-skin-hair-specialist?edit=yes'>Edit Booking</a><br/><span>Unfortunately this time slot is not available anymore. Please remove this item and book again.</span></div></div></li></ul>";

        errorShow.innerHTML = errorHTML;
        document.body.appendChild(errorShow);

        if(document.querySelector(".cart__checkout-button"))
        {
          document.querySelector(".cart__checkout-button").setAttribute("disabled", "disabled");
        }
        
        if(document.querySelector(".rebuy-cart__checkout-button"))
        {
          document.querySelector(".rebuy-cart__checkout-button").setAttribute("disabled", "disabled");
        }
        
        if(document.querySelector("#continue_button"))
        {
          document.querySelector("#continue_button").setAttribute("disabled", "disabled");
        } 
      }
      return false;
    } else {
        if(document.querySelector(".cart__checkout-button"))
        {
          document.querySelector(".cart__checkout-button").removeAttribute("disabled");
        }
        
        if(document.querySelector(".rebuy-cart__checkout-button"))
        {
          document.querySelector(".rebuy-cart__checkout-button").removeAttribute("disabled");
        }
        
        if(document.querySelector("#continue_button"))
        {
          document.querySelector("#continue_button").removeAttribute("disabled");
        }
    }
  });
});